import axios, { GenericAbortSignal } from 'axios'
import { Buffer } from 'buffer'
import { iContractInfoExtSys, iMsgActionsExtSys } from '../types/ien.types'
import { iSubmitExtSys, iSubmitResponse, iUploadResponse } from '../types/submit.types'
import { iSubmitsInfoExtSys } from '../types/submitsInfo.types'

class IenApi {

  api = axios.create()

  viewMsgExtSys = (extSystem: string, extId: string) =>
    this.api.head(`${extSystem}/api/ekomunikace/v1/podani/${extId}/zobrazeni`)
      .then(res => res.data)

  downloadAttachmentExtSys = (extSystem: string, extId: string, fileId: string) =>
    this.api.get(`${extSystem}/api/ekomunikace/v1/podani/${extId}/prilohy/${fileId}/soubor`, { responseType: 'blob' })
      .then(res => res.data)

  getMsgActionExtSys = (extSystem: string, extId: string) =>
    this.api.get<iMsgActionsExtSys>(`${extSystem}/api/ekomunikace/v1/podani/${extId}/opravneni`)
      .then(res => res.data)

  getContractSubmsInfoExtSys = (extSystem: string, extId: string) =>
    this.api.get<iContractInfoExtSys>(`${extSystem}/api/ekomunikace/v1/zadavaci-postupy/${extId}`)
      .then(res => res.data)

  getContractSubmsInfoTypeExtSys = (extSystem: string, extId: string, typeCode: string, responseId?: string) =>
    this.api.get<iSubmitsInfoExtSys>(`${extSystem}/api/ekomunikace/v1/zadavaci-postupy/${extId}/info-pro-podani`, {
      params: {
        typ: typeCode,
        odpovedNa: responseId
      }
    })
      .then(res => res.data)

  submitExtSys = (extSystem: string, submitData: iSubmitExtSys) =>
    this.api.post<iSubmitResponse>(`${extSystem}/api/ekomunikace/v1/podani`, submitData)
      .then(res => res.data)

  cancelSubmsExtSys = (extSystem: string, submsId: string) =>
    this.api.head(`${extSystem}/api/ekomunikace/v1/podani/${submsId}/zneplatnit `)
      .then(res => res.data)

  fileUpload = async (
    extSystem: string,
    file: File,
    fileContentData: Buffer,
    onUploadProgress?: (progressEvent: any) => void,
    signal?: GenericAbortSignal
  ) =>
    this.api.post<iUploadResponse>(`${extSystem}/api/ekomunikace/v1/prilohy`,
      fileContentData,
      {
        headers: { 'Content-Type': file.type },
        // maxContentLength: Infinity,
        // maxBodyLength: Infinity,
        onUploadProgress,
        signal,
      })
      .then(res => res.data)

  fileUploadDelete = (extSystem: string, tmpId: string) =>
    this.api.delete(`${extSystem}/api/ekomunikace/v1/prilohy/${tmpId}`)
      .then(res => res.data)
}

export default new IenApi()
